module.exports = "\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/panels/general-system-info/general-system-info.component.css
// module id = ./src/app/profile/panels/general-system-info/general-system-info.component.css
// module chunks = main